import { LoadScript } from "@react-google-maps/api";
import React, { createContext, useContext, useEffect, useState } from "react";

interface GoogleMapsContextType {
  isReady: boolean;
}

const GoogleMapsContext = createContext<GoogleMapsContextType | undefined>(undefined);

export const useIsGoogleMapsApiReady = (): boolean => {
  const context = useContext(GoogleMapsContext);
  if (context === undefined) {
    throw new Error("useGoogleMapsReady must be used within a SharedGoogleMapsProvider");
  }
  return context.isReady;
};

interface SharedGoogleMapsProviderProps {
  children: React.ReactNode;
}

export const SharedGoogleMapsProvider: React.FC<SharedGoogleMapsProviderProps> = ({ children }) => {
  const [isReady, setIsReady] = useState(false);

  return (
    <GoogleMapsContext.Provider value={{ isReady }}>
      <LoadScript
        id="script-loader"
        googleMapsApiKey="AIzaSyDqHtySrYhBtTx6crOmWKHjA0ePGc5_BV0"
        loadingElement={<></>}
        onLoad={() => setIsReady(true)}
        onError={() => console.error("Failed to load Google Maps API")}
      >
        {children}
      </LoadScript>
    </GoogleMapsContext.Provider>
  );
};
